import React from "react";
import { Tutorial } from "../pagination/types";
import { Link } from "react-router-dom";
import tfuel from "../../assets/svgs/tfuel.svg";

const Videocard = ({
  id,
  videoCardImage,
  tutor,
  price,
  tutorImage,
  tutorialName,
}: Tutorial) => {
  return (
    <div className="h-[28vh] grid grid-rows-[70%_30%] font-poppins text-main-black mb-4">
      <Link to={`tutorial/${id}`}>
        <div className="">{videoCardImage}</div>
        <div className="grid grid-cols-[10%_90%] mt-2">
          <div>{tutorImage}</div>
          <div className="ml-2">
            <p className="text-[13px] font-bold">{tutorialName}</p>
            <div className="flex">
              <p className="text-[12px] font-light text-main-blue">{tutor}</p>
              <div className="flex text-[12px] font-bold ml-16">
                <p>{price}</p>
                <img src={tfuel} alt="" />
              </div>
            </div>
          </div>
        </div>
    </Link>
    </div>
  );
};

export default Videocard;
